import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Es solo para cristianos?',
    a: 'Es para cualquier persona que esté atravesando una crisis profunda (duelo, pérdida, soledad) y busque una perspectiva espiritual profunda y honesta.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital de acceso inmediato. Puedes leerlo en tu celular, tablet o imprimirlo.'
  }, {
    q: '¿Por qué tan barato?',
    a: 'Como te dije, estoy lanzando esta versión de validación. El precio subirá a $27 pronto. Aprovecha ahora.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Si en los primeros 7 días sientes que no aporta valor a tu proceso, te devuelvo tus $6.36 sin preguntas. El riesgo es 100% mío.'
  }];
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-288">
      <div className="max-w-[680px] mx-auto" data-id="element-289">
        <h2 className="text-xl md:text-2xl font-serif text-center mb-5 md:mb-8 text-[var(--text-heading)]" data-id="element-290">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-1.5 md:space-y-2" data-id="element-291">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-[var(--bg-card)] rounded-lg border border-[var(--border-subtle)] shadow-sm overflow-hidden" data-id="element-292">
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between gap-3 p-3.5 md:p-5 text-left" data-id="element-293">
                <span className="font-serif font-bold text-[var(--text-heading)] text-sm leading-snug" data-id="element-294">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.25
            }} className="flex-shrink-0 text-[var(--accent)]" data-id="element-295">
                  <ChevronDown className="w-4 h-4" data-id="element-296" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-297">
                {openIndex === i && <motion.div key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-298">
                    <p className="px-3.5 md:px-5 pb-3.5 md:pb-5 text-[var(--text-muted)] text-xs md:text-sm leading-relaxed border-t border-[var(--border-subtle)] pt-3" data-id="element-299">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}